import React from 'react';
import IconLabel from 'components/common/IconLabel';
import cn from 'classnames';
import allAmenities from 'amenities';

const defaultIcon = 'elevator';

export default ({ amenities }) => {
  const amenitiesLowerCase = amenities.map(x => x.toLowerCase());

  const amenitiesToShow = allAmenities
    .map((a, i) => (
      <div key={i} className={cn("amenity", "col-md-4", "col-sm-6", "mb-3", { disabled: !amenitiesLowerCase.includes(a.lowerCase) })}>
        <IconLabel icon={a.icon || defaultIcon} label={a.text} isHorizontal={true}/>
      </div>
    ));

  return (
    <div className="row no-gutters">
      {amenitiesToShow}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/Amenities.js